import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Inspection } from '../classes/inspection';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class InspectionService {
    API_INSPECTION_URL = config.serverAddress + ':' + config.serverPort + '/inspection/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_INSPECTION_URL + 'all');
    }
    getByID(id: string | null) {
        return this.http.get(this.API_INSPECTION_URL + id);
    }
    getByIDPA(idPA: string) {
        return this.http.get(this.API_INSPECTION_URL + 'pa/' + idPA);
    }
    getByIDUser(idUser: string) {
        return this.http.get(this.API_INSPECTION_URL + 'user/' + idUser);
    }
    getByIDContract(idContract: string | null) {
        return this.http.get(this.API_INSPECTION_URL + 'contract/' + idContract);
    }
    getByIDInspectionState(idInspectionStateList: Array<number>) {
        return this.http.post(this.API_INSPECTION_URL + 'inspection-state', {id_inspection_state_list: idInspectionStateList});
    }
    search(inspectionSearchParams: any) {
        return this.http.post(this.API_INSPECTION_URL + 'search', inspectionSearchParams);
    }
    generateReport(id: string | null) {
        return this.http.get(this.API_INSPECTION_URL + 'report/' + id, { responseType: 'blob'});
    }
    upload(formData: FormData) {
        return this.http.post(this.API_INSPECTION_URL + 'upload', formData);
    }
    create(inspection: Inspection) {
        return this.http.post(this.API_INSPECTION_URL + 'create', inspection);
    }
    update(inspection: Inspection) {
        return this.http.put(this.API_INSPECTION_URL + 'update', inspection);
    }
    delete(id: number) {
        return this.http.delete(this.API_INSPECTION_URL + 'delete/' + id);
    }
}
